import { ColorValue, StyleSheet, View } from "react-native";
import { useTheme } from "../hooks/use-theme";

type FullWidthLineProps = {
    color?: ColorValue;
};

const FullWidthLine = ({ color }: FullWidthLineProps) => {
    const styles = useStyles();

    return <View style={[styles.line, { backgroundColor: color }]} />;
};

const useStyles = () => {
    const { marginSize, colors } = useTheme();

    return StyleSheet.create({
        line: {
            marginHorizontal: -marginSize,
            height: 1,
            backgroundColor: colors.lighterGrey,
        },
    });
};

export default FullWidthLine;
